"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecaptchaProvider = void 0;
exports.useRecaptchaForm = useRecaptchaForm;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_google_recaptcha_v3_1 = require("react-google-recaptcha-v3");
const RecaptchaAdjuster_1 = require("./RecaptchaAdjuster");
/**
 * A wrapper component that provides the GoogleReCaptchaProvider context
 * to its children. This allows children components to use useGoogleReCaptcha (or custom hooks like useRecaptchaForm).
 */
const RecaptchaProvider = ({ siteKey, children, isEnterprise = true, badgePosition = 'bottomright', }) => {
    if (!siteKey) {
        console.error('reCAPTCHA siteKey is required for RecaptchaProvider.');
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }); // Render children without reCAPTCHA if key is missing
    }
    return ((0, jsx_runtime_1.jsxs)(react_google_recaptcha_v3_1.GoogleReCaptchaProvider, { reCaptchaKey: siteKey, useEnterprise: isEnterprise, container: {
            parameters: {
                badge: badgePosition,
            },
        }, children: [children, (0, jsx_runtime_1.jsx)(RecaptchaAdjuster_1.RecaptchaAdjuster, {})] }));
};
exports.RecaptchaProvider = RecaptchaProvider;
function useRecaptchaForm() {
    const { executeRecaptcha } = (0, react_google_recaptcha_v3_1.useGoogleReCaptcha)();
    const recaptchaReady = typeof executeRecaptcha === 'function';
    return {
        executeRecaptcha,
        recaptchaReady,
    };
}
